<template>

  <v-list dense>

    <!-- Back -->
    <v-list-item @click="$emit('back')">
      <v-list-item-icon>
        <v-icon disabled>mdi-chevron-left</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>Rotation</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item-group
      @change="onRotateChange"
      mandatory
      :value="rotation"
    >
      <v-list-item value="default"
                   color="primary"
      >
        <v-list-item-content>
          <v-list-item-title>Default</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item value="90"
                   color="primary"
      >
        <v-list-item-content>
          <v-list-item-title>90° Clockwise ↻</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item value="180"
                   color="primary"
      >
        <v-list-item-content>
          <v-list-item-title>180° Clockwise ↻</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item value="270"
                   color="primary"
      >
        <v-list-item-content>
          <v-list-item-title>270° Clockwise ↻</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>

  </v-list>

</template>

<script lang="js">

// #region Imports

/* vuex */
import { mapState } from 'vuex';
import {SELECT_ROTATION} from "@/utils/action-types";

/* Telestream */

// #endregion Imports

export default {

  // #region Properties

  name:     'RotationMenu',
  computed: {
    ...mapState([
      'video'
    ]),
    rotation(){
      console.log(this.video.rotation);
      return this.video.rotation;
    }
  },

  // #endregion Properties

  // #region Events

  methods: {
    onRotateChange(value) {
      const ratio = this.video.element.clientHeight / this.video.element.clientWidth;
      switch (value) {
      case "default":
        this.video.element.style.transform = "none";
        this.$store.dispatch(SELECT_ROTATION, null);
        break;

      case "90":
        this.video.element.style.transform = `scale(${ratio}) rotate(90deg)`;
        this.video.element.style.transformOrigin = "center";
        this.$store.dispatch(SELECT_ROTATION, "90");
        break;

      case "180":
        this.video.element.style.transform = "rotate(180deg)";
        this.video.element.style.transformOrigin = "center";
        this.$store.dispatch(SELECT_ROTATION, "180");
        break;

      case "270":
        this.video.element.style.transform = `scale(${ratio}) rotate(270deg)`;
        this.video.element.style.transformOrigin = "center";
        this.$store.dispatch(SELECT_ROTATION, "270");
        break;
      }
    }
  }

  // #endregion Events

}

</script>
